import { render, staticRenderFns } from "./ProductionPost.vue?vue&type=template&id=c0034098&scoped=true&"
import script from "./ProductionPost.vue?vue&type=script&lang=js&"
export * from "./ProductionPost.vue?vue&type=script&lang=js&"
import style0 from "./ProductionPost.vue?vue&type=style&index=0&id=c0034098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0034098",
  null
  
)

export default component.exports